<template>
    <table-base :filter="filter" :headers="headers" :api-data="apiData" :sorting="sorting" :items-field="itemsField" :edit-page-name="editPageName" :api-method="apiMethod" :claim-name="claimName" :form-title="formTitle" :excel-title="excelTitle" :has-edit-page="hasEditPage" :table-form="testResultForm" :refresh-key="refreshKey" :show-expand="false" />
</template>

<script>
    export default {
        props: [
            'filter',
            'refreshKey'
        ],
        components: {
            tableBase: () => import('../components/TableBase'),
        },
        data() {
            return {
                testResultForm: () => import('../forms/TestResultForm'),
                headers: [
                    { text: 'Sample Test', value: 'sampleTestId', table: 'sampleTests', form: () => import('../forms/SampleTestForm') },
                    { text: 'Result', value: 'result' },
                    { text: 'Tested On', value: 'testedOn', format: this.formatDate },
                    { text: 'Precision', value: 'precision', format: this.formatEnum },
                    { text: 'File', value: 'fileId', table: 'files', form: () => import('../forms/FileForm') },
                    { text: '', value: 'action' }
                ],
                apiData: {
                    files: [],
                    sampleTests: [],
                    items: []
                },
                sorting: [
                    { column: "testedOn", direction: "descending" },
                    { column: "sampleTestId", direction: "ascending" },
                ],
                itemsField: 'testResults',
                editPageName: 'testResult',
                apiMethod: 'TestResults',
                claimName: 'TestResults',
                formTitle: 'Test Result',
                excelTitle: 'Test Results',
                hasEditPage: false,
            }
        },
    };
</script>
